module.exports = __webpack_public_path__ + "static/media/blueVert.0c878c0a.png";